// React
import React, { useEffect, useState } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import { Helmet } from "react-helmet";
// Style
import "./App.css";
import "../src/styles/Main.scss";
// Components
import PosMain from "./pages/pos/PosMain";
import OrderMain from "./pages/menu/OrderMain";
import AdminMain from "./pages/menu/AdminMain";
import CloseStore from "./pages/menu/CloseStore";
import PaymentSelect from "./pages/payment/PaymentSelect";
import PaymentCash from "./pages/payment/PaymentCash";
import PaymentNPay from "./pages/payment/PaymentNPay";
import PaymentKakaopay from "./pages/payment/PaymentKakaopay";
import PaymentMembership from "./pages/payment/PaymentMembership";
import useEventTimeout from "./useHooks/useEventTimeout";
import ADView from "./components/menu/common/ADView";
import PaymentSuccess from "./pages/payment/PaymentSuccess";
import OrderHistory from "./pages/payment/OrderHistory";
import BotPopup from "./pages/menu/BotPopup";
// Recoil
import { useRecoilState, useRecoilValue } from "recoil";
import { isAdminMode, isRobot } from "./atom/menu";
import NotFound from "./pages/Notfound/Notfound";
import Header from "./pages/Introduction/components/Header";
import Footer from "./pages/Introduction/components/Footer";

const PATH_SOLUTION_MAP: { [key: string]: string } = {
  "/": "포스를",
  "/menu": "메뉴를",
};

function App() {
  const location = useLocation();
  const isMenu = location.pathname.split("/").includes("menu");
  const [isAdminPopup, setIsAdminPopup] = useRecoilState(isAdminMode);
  const robotView = useRecoilValue(isRobot);

  const adminPopupControl = () => {
    setIsAdminPopup(false);
  };

  const [isAd, setIsAd] = useState<boolean>(false);

  // **기능정의**
  // 광고가 떠있다가 터치하면 사라짐
  // [isAd 값으로 광고 상태 구분]
  // *1분간 동작 없으면 광고 표시
  useEventTimeout(() => viewAD());
  const viewAD = () => {
    if (location.pathname !== "/") {
      setIsAd(true);
    }
  };

  // **기능정의**
  // 로고 3번 클릭 시, 관리자 페이지 이동 (1초안에 3번 클릭)
  const tripleClick = () => {
    setIsAdminPopup(true);
  };
  useEffect(() => {
    const logoEle = document.getElementById("triple");
    if (logoEle) {
      logoEle.addEventListener("click", function (e) {
        tripleClick();
      });
    }
  }, []);

  return (
    <div className="App">
      <Helmet>
        <meta name="viewport" content="width=device-width, initial-scale=0.3" />
      </Helmet>
      <div className="main-wrap">
        {/* <div className="main-head-wrap">
          <div className="info-text">
            브이디{PATH_SOLUTION_MAP[location.pathname] ?? "솔루션을"}{" "}
            체험해보세요
          </div>
        </div> */}
        <Header product={isMenu ? "menu" : "pos"} />

        <div className="main-content-wrap">
          <div className="ipad-wrap1">
            <div className="ipad-wrap2">
              <div className="hole">
                <div className="hole-inner"></div>
              </div>
              <div className="ipad-wrap3" id="sense">
                <Routes>
                  <Route path="/" Component={PosMain} />
                  <Route path="/menu" Component={OrderMain} />
                  <Route
                    path="/menu/order/membership"
                    Component={PaymentMembership}
                  />
                  {/* <Route path='/menu/order/confirm' Component={OrderConfirm} /> */}
                  <Route path="/menu/order/payment" Component={PaymentSelect} />
                  <Route
                    path="/menu/order/payment/cash"
                    Component={PaymentCash}
                  />
                  <Route
                    path="/menu/order/payment/npay"
                    Component={PaymentNPay}
                  />
                  <Route
                    path="/menu/order/payment/kakao"
                    Component={PaymentKakaopay}
                  />
                  <Route
                    path="/menu/order/payment/success"
                    Component={PaymentSuccess}
                  />
                  <Route path="/menu/order/history" Component={OrderHistory} />
                  <Route path="/close" Component={CloseStore} />
                  <Route path="*" element={<NotFound />} />
                </Routes>
                <ADView state={isAd} setState={setIsAd} />
                {isAdminPopup && <AdminMain action={adminPopupControl} />}
                {robotView && <BotPopup />}
              </div>
            </div>
          </div>
        </div>

        {/* <Footer /> */}
      </div>
    </div>
  );
}

export default App;
